import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {TheBorder} from "../../TheBorder";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheBorderAvalancheIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController:FlowStateController):void {
        TheBorder.clusterWinView.hideAll();

        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => flowStateController.finish()});
        tl.add(() => SlotGame.apiPlugin.betHandler.zeroBet());
        if(tl.duration() == 0) {
            tl.add(gsap.to(this, {duration : 0.001}));
        }
    }
}